module.exports = __webpack_public_path__ + "img/13.f673b814.jpg";